import { render } from "./CollectionDialog.vue?vue&type=template&id=dc46f2e2"
import script from "./CollectionDialog.vue?vue&type=script&lang=js"
export * from "./CollectionDialog.vue?vue&type=script&lang=js"

import "./CollectionDialog.vue?vue&type=style&index=0&id=dc46f2e2&lang=scss"

import exportComponent from "D:\\wwwroot\\mld\\vue-source\\mileIsland\\node_modules\\.store\\vue-loader@16.8.3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__